<style lang="scss" scoped>
.name-mobile-input {
  width: 300px;
  .el-input {
    width: 110px;
  }
}
.export_label {
  width: 100px;
  margin-top: 20px;
  display: inline-block;
}
</style>
<template>
  <!-- 业绩统计 -->
  <div>
    <!-- <h1>客户UV报表</h1> -->
    <SpFinder
      id="1"
      ref="finder"
      class="customerNumber"
      title="客户UV报表"
      :no-selection="true"
      :url="{
        data: finderConfig.requestUrl
      }"
      :show-tool-bar="false"
      :setting="finderConfig.setting"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      :search="finderConfig.search"
      :columns="finderConfig.columns"
      :actions="finderConfig.actions"
      @reset="onFinderReset"
    >
      <template slot="month">
        <el-date-picker
          v-model="params.month"
          style="min-width: 370px"
          type="month"
          value-format="yyyy-MM"
          start-placeholder="开始月份"
          :picker-options="pickerOptions"
        />
      </template>
      <template slot="guide">
        <span class="m-r-6">门店</span>
        <el-input
          v-model="storeNum"
          placeholder="全部门店"
          class="input-m m-r-6"
          :disabled="true"
          style="width: 240px"
        >
          <div slot="append">
            <el-link
              type="primary"
              style="margin-right: 10px"
              @click="storeVisible = true"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              @click="clearStore"
            >
              重置
            </el-link>
          </div>
        </el-input>
      </template>
      <template v-slot:name="{ value }">
        <el-input
          v-model="value.keyword"
          class="name-mobile-input"
          placeholder="请输入内容"
        >
          <el-select
            slot="prepend"
            v-model="keywordType"
            style="width: 120px"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="(item, index) in keyWordMap"
              :key="index"
              :label="item"
              :value="index"
            />
          </el-select>
        </el-input>
      </template>
    </SpFinder>
    <!-- 编辑门店 -->

    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />

    <!-- 导出报表对话框 -->
    <SpExportList
      v-model="exportDialogVisible"
      :show-store-select="true"
      :files-type="9"
      export-date="month"
      is-date-single
      include-current-date
      :show-sales-person-status="showSalesPersonStatus"
    />
  </div>
</template>

<script>
import initFinderConfig from './UVReportFinder'
export default {
  name: 'Profitlist',
  data () {
    const config = initFinderConfig(this)
    const keyWordMap = {
      'employee_numbers': '员工工号',
      'employee_name': '员工姓名',
      'mobile': '手机号'
    }
    return {
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      },
      finderConfig: config, // finder配置
      selectStoreData: [], //门店选择结果
      storeVisible: false, //
      storeNum: null,
      keyWordMap,
      keywordType: 'employee_numbers',
      keyword: '',
      params: {},
      searchQuery: {},
      dialogVisible: false,
      /**
       * 导出数据
       */
      exportDate: null,
      exportStore: null,
      exportDialogVisible: false,
      showSalesPersonStatus: true
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    beforeSearch (params) {
      params[this.keywordType] = params.keyword
      params['store_ids'] =
        (this.selectStoreData.length && this.selectStoreData.map((d) => d.store_id) + '') || null
      params['month'] = this.params.month || null
      console.log('beforeSearch:', params)
      return params
    },
    // 搜索重置
    onFinderReset () {
      this.selectStoreData = []
      this.keywordType = 'employee_numbers'
      this.storeNum = null
      this.params = {}
      this.keyword = ''
    },
    //重置门店选择
    clearStore () {
      this.storeIds = []
      this.storeNum = ''
      this.params.store_bn = []
      this.selectStoreData = []
    },
    // 选择门店
    chooseStore (selectdata, storeids) {
      console.log(selectdata, 'selectdataselectdata')
      this.selectStoreData = selectdata
      this.storeIds = storeids
      let storeBns = []
      selectdata.forEach((v) => {
        storeBns = storeBns.concat(v.store_bn)
      })
      this.params.store_bn = storeBns
      this.storeNum = '已选择' + selectdata.length + '家门店'
      this.storeVisible = false
    },
    async exportReport () {
      await this.$api.performance.exportReport({
        employee_numbers: '',
        store_ids:
          (this.selectStoreData.length && this.selectStoreData.map((d) => d.store_id) + '') || null,
        month: this.exportDate
      })
      this.dialogVisible = false
    }
  }
}
</script>
